import {
  AppConstants,
  conceptCodes,
  CONTACT_ADD_NOTE,
  EXISTING_CUSTOMER_NOTE,
  JUKServices,
  MLY_IDS,
  MOBILE_ADD_NOTE,
  serviceDetailsLabels,
  stepTypes,
  VIN_LABELS,
} from "../constants/constant";
import {
  handleCommercialPropertyDetails,
  handleMLYResidential,
  addFrequencyNote,
} from "./generateNotesHelper";
import {
  Element,
  FormValues,
  SchedulerConfig,
} from "../Interface/scheduler/form";
import { checkBrandsForPricingEstimate } from "./checkBrandsForPricingEstimate";
import {
  Field,
  Element as PricingElement,
} from "../feature/servicePricingTabs/components/ServiceTabDetails.interface";
import { capitalizeFirstLetter } from "./utility";

export function generateNotes(
  formValues: FormValues,
  formConfig: SchedulerConfig,
  pauseLead: boolean,
  selectedOffer: string,
  optIn: boolean,
  emailOptOut: boolean,
  warranty?: boolean,
  push5UMB17Text?: boolean
) {
  const {
    carServiceSelection,
    "mobile-service-selection": mobileServiceSelection,
    [AppConstants.MOBILE_ADDRESS]: mobileAddress,
    [AppConstants.MOBILE_ZIPCODE]: mobileZipcode,
    dropOffLocationRadioLabelText,
    dbaName,
    leadSourceId,
    leadSourceName,
    serviceRequestImage = [],
    serviceRequestImage1 = [],
    applianceBrand = {},
    wellnessSubscription = "",
    manufacturerWarranty = "",
    secondarySource,
    businessname,
    servicetype,
    servicerequest,
    proTypeName,
    serviceCategoryName,
    serviceName,
    categoryBasedQAs = [],
    multiservicecategory = [],
    note: comments,
    os_flow_50Mile_note,
    Other = "",
    existingcustomer,
    bagQuantity,
    bagPrice,
    serviceScenarioType,
    estimatedPrice,
    serviceDisclaimer = "",
    floor = "",
    shelvingstorage = "",
    financingInterest,
    vin = "",
    license = "",
    modelYear = "",
    make = "",
    model = "",
    bodyClass = "",
  } = formValues;
  const primarySource = sessionStorage.getItem("primarySource");
  let servicePageConfig: Element[];
  let contactUsPageConfig: Element[];
  formConfig?.steps.forEach((step) => {
    if (step.steptype === stepTypes.HOW_WE_CAN_REACH) {
      servicePageConfig = step.elements;
    } else if (step.id === AppConstants.CONTACT_US_ID) {
      contactUsPageConfig = step.elements;
    }
  });

  const contactUsFields =
    contactUsPageConfig?.find((config) => config.type === "form")?.fields || [];

  const targetElement =
    servicePageConfig?.find((config) => config.type === "form")?.fields || [];

  let pricingFields: Field[] = [];
  if (Array.isArray(serviceScenarioType?.elements)) {
    serviceScenarioType?.elements.forEach((el: PricingElement) => {
      if (el.type === "form" && Array.isArray(el.fields)) {
        pricingFields = pricingFields.concat(el.fields);
      }
    });
  }

  const elementFields = [
    ...contactUsFields,
    ...targetElement,
    ...pricingFields,
  ];
  const displayLabels = {};
  elementFields?.forEach((field) => {
    if (field.confirmationlabel) {
      displayLabels[field.id] = field.confirmationlabel;
    }
  });
  const notesArray: string[] = [];
  const displayNotesArray: string[] = [];
  let displayDisclaimer: string = "";

  function isJUKFullService() {
    if (formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE) {
      return serviceName === JUKServices.FULL_SERVICE_JUNK_REMOVAL;
    }
    return true;
  }

  function isCommercialService() {
    if (formValues?.servicetype === AppConstants.COMMERCIAL_TEXT) {
      return true;
    }
    return false;
  }

  function handleServiceRequestImage() {
    if (serviceRequestImage?.length) {
      const selectedRequests = serviceRequestImage.map((item) => item.label);
      const label =
        displayLabels["serviceRequestImage"] ||
        serviceDetailsLabels.SERVICE_SELECTED;
      const serviceRequestImageVal = `${label}: ${selectedRequests.join(", ")}`;
      displayNotesArray.push(serviceRequestImageVal);
      notesArray.push(serviceRequestImageVal);
    }
  }

  function handleServiceRequestImage1() {
    if (serviceRequestImage1?.length) {
      const paintRequests = serviceRequestImage1.map((item) => item.label);
      const label =
        displayLabels["serviceRequestImage1"] ||
        serviceDetailsLabels.SERVICE_FOR;
      const servicePaintRequests = `${label}: ${paintRequests.join(",")}`;
      displayNotesArray.push(servicePaintRequests);
      notesArray.push(servicePaintRequests);
    }
  }

  function handleApplianceBrand() {
    //Appliance brand
    if (applianceBrand?.makeName) {
      const label =
        displayLabels["applianceBrand"] || serviceDetailsLabels.APPLIANCE_BRAND;
      const applianceBrandVal = `${label}: ${applianceBrand?.makeName}`;
      displayNotesArray.push(applianceBrandVal);
      notesArray.push(applianceBrandVal);
    }
  }

  function handleAddC811Note() {
    if (
      formConfig?.conceptCode === conceptCodes.MLY_CONCEPT_CODE &&
      formValues?.isCallBackEnabled
    ) {
      notesArray.push("C811");
    }
  }

  function handleWellnessSubscription() {
    //Wellness subscription
    if (wellnessSubscription.length) {
      const label =
        displayLabels["wellnessSubscription"] ||
        serviceDetailsLabels.APPLIANCE_WELLNESS_PROGRAM_SUBCRIPTION;
      const wellnessSubscriptionVal = `${label}: ${wellnessSubscription}`;
      displayNotesArray.push(wellnessSubscriptionVal);
    }
  }

  function handleManufacturerWarranty() {
    //Manufacture warranty
    if (manufacturerWarranty.length) {
      const label =
        displayLabels["manufacturerWarranty"] || serviceDetailsLabels.WARRANTY;
      const manufacturerWarrantyVal = `${label}: ${manufacturerWarranty}`;
      displayNotesArray.push(manufacturerWarrantyVal);
    }
  }

  function handleComments() {
    //comments
    if (comments && isJUKFullService()) {
      const label = displayLabels["note"] || serviceDetailsLabels.MESSAGE;
      const commentsVal = `${label}: ${comments}`;
      notesArray.push(commentsVal);
      displayNotesArray.push(commentsVal);
    }
  }

  function handleFiftyMileNote() {
    // 50 Mile Note
    if (os_flow_50Mile_note) {
      notesArray.push(os_flow_50Mile_note);
    }
  }
  function handleMobileServiceNotes() {
    // Mobile Service Notes
    if (carServiceSelection === AppConstants.MOBILE_SERVICE_ID) {
      if (mobileServiceSelection === "contact-address") {
        notesArray.push(CONTACT_ADD_NOTE);
        displayNotesArray.push(CONTACT_ADD_NOTE);
      } else {
        const mobileNote = `${MOBILE_ADD_NOTE} ${mobileAddress} ${mobileZipcode}`;
        notesArray.push(mobileNote);
        displayNotesArray.push(mobileNote);
      }
    }
  }

  function handleDropOffServiceNotes() {
    // Drop-off Service Notes
    if (carServiceSelection === AppConstants.DROPOFF_SERVICE_ID) {
      const dropOffNote = `${dropOffLocationRadioLabelText} ${dbaName}`;
      notesArray.push(dropOffNote);
      displayNotesArray.push(dropOffNote);
    }
  }
  function handlePauseLeadNote() {
    // Pause Lead
    if (
      (pauseLead && !checkBrandsForPricingEstimate(formConfig.conceptCode)) ||
      push5UMB17Text
    ) {
      notesArray.push(AppConstants.ID_5UBM17_TEXT);
    }
  }

  function handleLeadSourceNote() {
    // Lead Source
    if (leadSourceId) {
      const label =
        displayLabels["howaboutus"] || serviceDetailsLabels.LEAD_SOURCE_TEXT;
      const leadSourceText = `${label}: ${leadSourceName}`;
      notesArray.push(leadSourceText);
      displayNotesArray.push(leadSourceText);
    }
  }

  function handlePrimarySourceNote() {
    // Primary & Secondary Sources
    if (primarySource) {
      const label =
        displayLabels["howaboutus"] ||
        AppConstants.HOW_DID_YOU_HEAR_ABOUT_US_TEXT;
      const primarySourceText = `${label}: ${primarySource}`;
      notesArray.push(primarySourceText);
      displayNotesArray.push(primarySourceText);
    }
  }
  function handleSecondarySourceNote() {
    if (secondarySource) {
      const secondarySourceText = `${AppConstants.SECONDARY_SOURCE_TEXT}: ${secondarySource}`;
      notesArray.push(secondarySourceText);
      displayNotesArray.push(secondarySourceText);
    }
  }

  function handleVinDetails() {
    if (vin) {
      const vinNotes = `${VIN_LABELS.VIN_LABEL}${vin}`;
      notesArray.push(vinNotes);
      displayNotesArray.push(vinNotes);
    }
    if ((vin || license) && modelYear && make) {
      const details = `${VIN_LABELS.YEAR_LABEL}${modelYear},${VIN_LABELS.MAKE_LABEL}${make},${VIN_LABELS.MODEL_LABEL}${model},${VIN_LABELS.STYLE_LABEL}${bodyClass}`;
      notesArray.push(details);
      displayNotesArray.push(details);
    }
  }

  function handleBusinessNameNote() {
    // Business Name & Service Request
    if (businessname && isCommercialService()) {
      const label =
        displayLabels["businessname"] ||
        serviceDetailsLabels.BUSINESS_NAME_TEXT;
      const businessNameText = `${label}: ${businessname}`;
      notesArray.push(businessNameText);
      displayNotesArray.push(businessNameText);
    }
  }

  function handleServiceTypeNote() {
    if (servicetype) {
      const label =
        displayLabels["userinfoServiceType"] ||
        displayLabels["servicetype"] ||
        displayLabels["cleaning-service"] ||
        serviceDetailsLabels.SERVICE_TYPE;
      const selectedServiceType =
        servicetype.charAt(0).toUpperCase() + servicetype.slice(1);
      const serviceTypeText = `${label}: ${selectedServiceType}`;
      notesArray.push(serviceTypeText);
      displayNotesArray.push(serviceTypeText);
    }
  }
  function handleServiceRequestNote() {
    if (servicerequest) {
      const label =
        displayLabels["servicerequest"] || serviceDetailsLabels.SERVICE_TYPE;
      const serviceRequestText = `${label}: ${servicerequest}`;
      notesArray.push(serviceRequestText);
      displayNotesArray.push(serviceRequestText);
    }
  }
  function handleProTypeNameNote() {
    // Pro Type Name
    if (proTypeName) {
      const proTypeText = `${serviceDetailsLabels.PROTYPE_TEXT}: ${proTypeName}`;
      notesArray.push(proTypeText);
      displayNotesArray.push(proTypeText);
    }
  }
  function handleServiceCategoryNameNote() {
    // Service Category Name
    if (serviceCategoryName) {
      const label =
        displayLabels["servicecategory"] ||
        serviceDetailsLabels.SERVICE_CATEGORY_NAME;
      const serviceCategoryText = `${label}: ${serviceCategoryName}`;
      notesArray.push(serviceCategoryText);
      displayNotesArray.push(serviceCategoryText);
    }
  }
  function handleServiceNameNote() {
    // Service Name
    if (serviceName) {
      const label =
        displayLabels["service"] || serviceDetailsLabels.SERVICE_TEXT;
      const serviceNameText = `${label}: ${serviceName}`;
      notesArray.push(serviceNameText);
      displayNotesArray.push(serviceNameText);
    }
  }

  function handleFlooringLevelNote() {
    //Dvw Flooring level
    if (floor) {
      const label = displayLabels["floor"] || serviceDetailsLabels.FLOOR_LABEL;
      const floorText = `${label}: ${floor}`;
      notesArray.push(floorText);
      displayNotesArray.push(floorText);
    }
  }
  function handleSelectOfferNote() {
    // Special Offer (only for notes in payload)
    if (selectedOffer) {
      const offerDetails = JSON.parse(selectedOffer);
      const code = offerDetails.couponcode || offerDetails.couponCode;
      const expiryDate =
        offerDetails.couponexpirydate || offerDetails.couponExpiryDate;
      const longDescription =
        offerDetails.longdescription || offerDetails.longDescription;
      const specialOfferTrackingCode = offerDetails?.fromSpecialOfferPopup
        ? AppConstants.SPECIAL_OFFER_POPUP_TRACKING_CODE
        : "";
      const offerParts = [
        offerDetails.title,
        offerDetails.description,
        expiryDate,
        code,
        longDescription,
        specialOfferTrackingCode,
      ].filter((part) => part && part.trim() !== "");
      const specialOfferText = `${AppConstants.SPECIAL_OFFER_TEXT}: ${offerParts.join(", ")}`;
      notesArray.push(specialOfferText);
    }
  }

  function handleOptInPreferences() {
    // Opt-In Preferences
    const optInText = optIn
      ? AppConstants.TEXT_OPTIN_YES
      : AppConstants.TEXT_OPTIN_NO;
    const emailOptText = `${AppConstants.EMAIL_OPT}: ${emailOptOut ? "No" : "Yes"}`;
    notesArray.push(optInText, emailOptText);
  }

  function handleCategorybasesQAsNotes() {
    // Category-Based Q&A Responses
    if (Array.isArray(categoryBasedQAs) && categoryBasedQAs.length > 0) {
      const formattedQAforNote = categoryBasedQAs
        .sort((a, b) => a.questionUISequence - b.questionUISequence)
        .map((item) => `${item.question}: ${item.answer}`);

      notesArray.push(...formattedQAforNote);
    }
  }
  function handleMultiServiceCategoriesNotes() {
    // Multi-Service Categories
    if (
      Array.isArray(multiservicecategory) &&
      multiservicecategory.length > 0
    ) {
      const multiServiceText = `${AppConstants.SERVICE_CATEGORIES_NOTE} ${multiservicecategory.join(", ")}`;
      notesArray.push(multiServiceText);
      displayNotesArray.push(multiServiceText);
    }
  }
  function handleOtherField() {
    //Other field for PLG/MDG
    if (Other) {
      notesArray.push(Other);
      displayNotesArray.push(Other);
    }
  }
  function handleWarrantyField() {
    // warrant true
    if (warranty) {
      const warrantyText = `${AppConstants.WARRANTY_TEXT}: ${warranty}`;
      notesArray.push(warrantyText);
    }
  }

  function handleExistingCustomerField() {
    if (existingcustomer === "true") {
      notesArray.push(EXISTING_CUSTOMER_NOTE);
    }
  }

  function handleFinancingInterest() {
    if (financingInterest) {
      notesArray.push(
        `${AppConstants.FINANCING_INTEREST}: ${capitalizeFirstLetter(financingInterest)}`
      );
    }
  }

  function handleBagQuantityAndPrice() {
    if (bagQuantity && displayLabels["counter_increment"]) {
      const label = displayLabels["counter_increment"];
      const bagLabel = Number(bagQuantity) === 1 ? "bag" : "bags";
      let bagQuantityText = `${label}: ${bagPrice}`;
      if (bagPrice && bagPrice !== "--") {
        bagQuantityText = `${label}: ${bagPrice} for ${bagQuantity} ${bagLabel}`;
      }
      notesArray.push(bagQuantityText);
      displayNotesArray.push(bagQuantityText);
    }
  }

  function handleEstimatedPrice() {
    if (estimatedPrice && displayLabels["pickupPrice"]) {
      const label = displayLabels["pickupPrice"];
      const estimatedPriceText = `${label}: ${estimatedPrice}`;
      notesArray.push(estimatedPriceText);
      displayNotesArray.push(estimatedPriceText);
    }
  }

  function handleServiceDisclaimer() {
    if (serviceDisclaimer) {
      displayDisclaimer = `*${serviceDisclaimer}`;
    }
  }

  function handleMLYEstimateNotes() {
    if (formConfig.conceptCode === conceptCodes.MLY_CONCEPT_CODE) {
      if (formValues[MLY_IDS.SERVICE] === MLY_IDS.RESIDENTIAL) {
        addFrequencyNote(formValues[MLY_IDS.FREQUENCY], notesArray);
        handleMLYResidential(formValues, notesArray);
      } else {
        addFrequencyNote(formValues[MLY_IDS.COMMERCIAL_FREQUENCY], notesArray);
        if (formValues?.[MLY_IDS.COMMERCIAL_MOVE_CLEAN] === "yes") {
          notesArray.push(MLY_IDS.MOVE_IN_OUT_CLEAN);
        }
        handleCommercialPropertyDetails(formValues, notesArray);
      }
    }
  }

  function handleShelvingStorage() {
    if (shelvingstorage) {
      const label =
        displayLabels["servicetype"] || serviceDetailsLabels.SERVICE_TYPE;
      const shelvingStorageText = `${label}: ${shelvingstorage}`;
      displayNotesArray.push(shelvingStorageText);
    }
  }

	function handleCommercialPropertyQuantityNote() {
		if (isCommercialService()) {
			const commercialPropertyQuantity = formValues['commercialInputFlow'];
			if (commercialPropertyQuantity) {
				const label = "Number of locations needing service";
				const commercialPropertyQuantityText = `${label}: ${commercialPropertyQuantity}`;
				notesArray.push(commercialPropertyQuantityText);
			}
		}
	}

  handleBagQuantityAndPrice();
  handleEstimatedPrice();
  handleServiceRequestImage();
  handleServiceRequestImage1();
  handleApplianceBrand();
  handleAddC811Note();
  handleWellnessSubscription();
  handleManufacturerWarranty();
  handleComments();
  handleFiftyMileNote();
  handleMobileServiceNotes();
  handleDropOffServiceNotes();
  handlePauseLeadNote();
  handleVinDetails();
  handleLeadSourceNote();
  handlePrimarySourceNote();
  handleSecondarySourceNote();
  handleBusinessNameNote();
  handleServiceTypeNote();
  handleMLYEstimateNotes();
  handleServiceRequestNote();
  handleProTypeNameNote();
  handleServiceCategoryNameNote();
  handleServiceNameNote();
  handleFlooringLevelNote();
  handleSelectOfferNote();
  handleOptInPreferences();
  handleCategorybasesQAsNotes();
  handleMultiServiceCategoriesNotes();
  handleOtherField();
  handleWarrantyField();
  handleExistingCustomerField();
  handleServiceDisclaimer();
  handleShelvingStorage();
  handleFinancingInterest();
	handleCommercialPropertyQuantityNote();
  // Final Output
  const note = notesArray.join(", ");
  const displayNotesForServiceDesc = displayNotesArray.join("|");

  return { note, displayNotesForServiceDesc, displayDisclaimer };
}
